import React, { useState, useContext, useEffect } from "react";
import CryptoContext from "../context/crypto/cryptoContext";
import NumberFormat from "react-number-format";
import { formatPrice } from "../helpers/format";
const Price = ({
  property,
  id,
  item,
  item1,
  style1,
  style2,
  style3,
}) => {
  const { livePriceData, currencySymbol } = useContext(CryptoContext);
  const [priceColor, setPriceColor] = useState("black");
  const [coinPrice, setCoinPrice] = useState(formatPrice(Number(item)));

  // const currencySymbol = getSymbolFromCurrency(localCurrency!==convt?localCurrency:convt);

  useEffect(() => {
    if (livePriceData) {
      if (coinPrice > livePriceData[id]) {
        setPriceColor("#e93847");
      } else if (coinPrice < livePriceData[id]) {
        setPriceColor("#45aa43");
      }

      setCoinPrice(formatPrice(livePriceData[id]));
    }

    setTimeout(() => setPriceColor("black"), 1500);
    //eslint-disable-next-line
  }, [livePriceData]);

  return (
    <td
      style={
        style1
          ? {
              ...style1,
            }
          : {}
      }
    >
      <div
        className="Home__MainTable-td"
        style={
          style2 && property === "price"
            ? {
                ...style2,
                color: priceColor,
              }
            : style2 && property !== "price"
            ? { ...style2 }
            : {}
        }
      >
        {property === "1dVolume" ? (
          <>
            <div>
              <NumberFormat
                value={Number(item1).toFixed(0)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={`${currencySymbol}${" "}`}
              />
            </div>
            <div
              style={
                style3
                  ? {
                      ...style3,
                    }
                  : {}
              }
            >
              <NumberFormat
                value={(Number(item1) / coinPrice).toFixed(0)}
                displayType={"text"}
                thousandSeparator={true}
              />
              {/* {Number(item1) / coinPrice > 1.0e10 && <br />} */}
              &nbsp;{id}
            </div>
          </>
        ) : (
          <div
            style={
              style3
                ? {
                    ...style3,
                  }
                : {}
            }
          >
            {property === "price" ? (
              <NumberFormat
                value={coinPrice}
                displayType={"text"}
                thousandSeparator={true}
                prefix={`${currencySymbol}${" "}`}
              />
            ) : (
              <p>{item}</p>
            )}
          </div>
        )}
      </div>
    </td>
  );
};

export default Price;
